import { FC, HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';
import { RDCModal, RDCModalBody, RDCModalFooter, RDCModalHeader } from '../RDCModal';
import { Headline } from 'src/UI';
import st from "./Modal.module.scss";

interface IModalProps extends HTMLAttributes<HTMLDivElement> {
	variant?: "blue" | "red";
	headerTitle: string;
	title?: string;
	text?: string;
	Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string | undefined; }>;
	Footer?: ReactNode;
	onClose: () => void;
};

const Modal: FC<IModalProps> = ( props ) => {

	const { variant, headerTitle, title, text, Icon, Footer, onClose, children, className, ...otherProps } = props;

	return (
		<RDCModal closeOnEsc onRequestClose={onClose} id="rdc_ask_savepreset_modal" className={classNames(variant, className)} {...otherProps}>
			<RDCModalHeader onClose={onClose}>{headerTitle}</RDCModalHeader>
			<RDCModalBody className={st.body}>
				{ !!Icon && <Icon width={120} height="auto" /> }
				{
					( title || text ) &&
					<div className={st.body__textBlock}>
						{ !!title && <Headline>{title}</Headline> }
						{ !!text && <p className='body-font'>{text}</p> }
					</div>
				}
				{ children }
			</RDCModalBody>
			{
				Footer &&
				<RDCModalFooter renderFooterLine={false}>
					{ Footer }
				</RDCModalFooter>
			}
		</RDCModal>
	);
};

export default Modal;
